export type ModuleDef = {
  id: string;
  modUid: string;
  label: string;
  group: string;
  path: string;
  description: string;
  entity: string;
};

export const MODULES: ModuleDef[] = [
  {
    id: "platform",
    modUid: "MOD-000",
    label: "Platform & security",
    group: "Foundation",
    path: "/app/platform",
    description: "Tenants, users, audit, workflow",
    entity: "platform_items",
  },
  {
    id: "company",
    modUid: "MOD-001",
    label: "Company master data",
    group: "Foundation",
    path: "/app/company",
    description: "Legal entities, org tree, fiscal calendar",
    entity: "org_units",
  },
  {
    id: "org-hierarchy",
    modUid: "MOD-001",
    label: "Company hierarchy",
    group: "Foundation",
    path: "/app/org-hierarchy",
    description: "Navigable org chart with HR visibility depth and BU leadership",
    entity: "org_units",
  },
  {
    id: "portfolio",
    modUid: "MOD-020",
    label: "Portfolio P&L",
    group: "Delivery",
    path: "/app/portfolio",
    description: "Director/VP actuals and projections — OP and GM",
    entity: "contracts",
  },
  {
    id: "company-admin",
    modUid: "MOD-001",
    label: "Company admin",
    group: "Foundation",
    path: "/app/company-admin",
    description: "Per-company timesheet cadence, hour floors, leave accrual, and burden",
    entity: "company_timekeeping_policies",
  },
  {
    id: "projects",
    modUid: "MOD-002",
    label: "Projects & WBS",
    group: "Delivery",
    path: "/app/projects",
    description: "Projects, WBS, funding ceilings, teams",
    entity: "projects",
  },
  {
    id: "planning",
    modUid: "MOD-003",
    label: "Planning / EAC",
    group: "Delivery",
    path: "/app/planning",
    description: "Budgets, forecasts, EAC / ETC",
    entity: "budgets",
  },
  {
    id: "timekeeping",
    modUid: "MOD-004",
    label: "Timekeeping",
    group: "Employee",
    path: "/app/timekeeping",
    description: "Period timesheets, charge codes, submit and corrections",
    entity: "timesheets",
  },
  {
    id: "charge-codes",
    modUid: "MOD-004",
    label: "Charge codes",
    group: "Delivery",
    path: "/app/charge-codes",
    description: "Create leave, B&P, G&A, and contract charge codes (VV.CCC.PER.CLIN[.TASK])",
    entity: "charge_codes",
  },
  {
    id: "expenses",
    modUid: "MOD-005",
    label: "Expenses & travel",
    group: "Employee",
    path: "/app/expenses",
    description: "Expense reports, receipts, per diem",
    entity: "expenses",
  },
  {
    id: "leave",
    modUid: "MOD-014",
    label: "Leave",
    group: "Employee",
    path: "/app/leave",
    description: "Leave balances and requests",
    entity: "leave_balances",
  },
  {
    id: "benefits",
    modUid: "MOD-023",
    label: "Benefits",
    group: "Employee",
    path: "/app/benefits",
    description: "Open enrollment and benefit plan enrollments",
    entity: "benefits",
  },
  {
    id: "payroll",
    modUid: "MOD-022",
    label: "Payroll",
    group: "Employee",
    path: "/app/payroll",
    description: "Compensation, bonuses, and W-4",
    entity: "compensation",
  },
  {
    id: "profile",
    modUid: "MOD-013",
    label: "My profile",
    group: "Employee",
    path: "/app/profile",
    description: "Home address and personal details",
    entity: "employee_profile",
  },
  {
    id: "documents",
    modUid: "MOD-018",
    label: "My documents",
    group: "Employee",
    path: "/app/documents",
    description: "HR documents such as non-compete agreements",
    entity: "hr_documents",
  },
  {
    id: "helpdesk",
    modUid: "MOD-021",
    label: "Help desk",
    group: "Employee",
    path: "/app/helpdesk",
    description: "Ask for help — routed to named domain owners or project finance assignees",
    entity: "helpdesk_tickets",
  },
  {
    id: "labor",
    modUid: "MOD-006",
    label: "Labor distribution",
    group: "Finance",
    path: "/app/labor",
    description: "Rates, burdens, payroll interface",
    entity: "labor_runs",
  },
  {
    id: "dcaa",
    modUid: "MOD-020",
    label: "DCAA compliance",
    group: "Finance",
    path: "/app/dcaa",
    description: "Unallowables, funds alerts, evidence packs",
    entity: "dcaa_controls",
  },
  {
    id: "gl",
    modUid: "MOD-007",
    label: "GL & close",
    group: "Finance",
    path: "/app/gl",
    description: "COA, journals, trial balance, close",
    entity: "journals",
  },
  {
    id: "ap",
    modUid: "MOD-008",
    label: "Accounts payable",
    group: "Finance",
    path: "/app/ap",
    description: "Vendors, vouchers, payments",
    entity: "ap_vouchers",
  },
  {
    id: "procurement",
    modUid: "MOD-009",
    label: "Procurement",
    group: "Supply",
    path: "/app/procurement",
    description: "Requisitions, POs, receiving",
    entity: "purchase_orders",
  },
  {
    id: "billing",
    modUid: "MOD-010",
    label: "Billing / AR",
    group: "Finance",
    path: "/app/billing",
    description: "Invoices, revenue, cash application",
    entity: "invoices",
  },
  {
    id: "contracts",
    modUid: "MOD-011",
    label: "Contracts",
    group: "Contracts",
    path: "/app/contracts",
    description: "Contracts, clients, CLIN pricing, delivery attribution",
    entity: "contracts",
  },
  {
    id: "subcontracts",
    modUid: "MOD-012",
    label: "Subcontracts",
    group: "Contracts",
    path: "/app/subcontracts",
    description: "Sub agreements, flowdowns, accruals",
    entity: "subcontracts",
  },
  {
    id: "hr",
    modUid: "MOD-013",
    label: "HR / employees",
    group: "HR",
    path: "/app/hr",
    description: "Employee master, labor categories",
    entity: "employees",
  },
  {
    id: "inventory",
    modUid: "MOD-015",
    label: "Inventory",
    group: "Supply",
    path: "/app/inventory",
    description: "Parts, warehouses, issues/receipts",
    entity: "inventory_items",
  },
  {
    id: "manufacturing",
    modUid: "MOD-016",
    label: "Manufacturing",
    group: "Supply",
    path: "/app/manufacturing",
    description: "BOMs, work orders, WIP",
    entity: "work_orders",
  },
  {
    id: "assets",
    modUid: "MOD-017",
    label: "Fixed assets",
    group: "Finance",
    path: "/app/assets",
    description: "Asset master, depreciation",
    entity: "fixed_assets",
  },
  {
    id: "integrations",
    modUid: "MOD-019",
    label: "Integrations",
    group: "Platform",
    path: "/app/integrations",
    description: "APIs, webhooks, import jobs",
    entity: "integrations",
  },
  {
    id: "bi",
    modUid: "MOD-020",
    label: "BI & dashboards",
    group: "Platform",
    path: "/app/bi",
    description: "Dashboards and executive views",
    entity: "bi_metrics",
  },
];

export type IntentResult = { label: string; path: string; hint: string };

export const INTENT_ACTIONS: IntentResult[] = [
  { label: "Submit my timesheet", path: "/app/timekeeping", hint: "Timekeeping" },
  { label: "Request a charge code", path: "/app/timekeeping", hint: "Timekeeping · Add row" },
  { label: "Create or approve charge codes", path: "/app/charge-codes", hint: "Charge codes" },
  { label: "Approve team timesheets", path: "/app/timekeeping?tab=approvals", hint: "Timekeeping · Approvals" },
  { label: "Configure timesheet periods", path: "/app/company-admin", hint: "Company admin" },
  { label: "File an expense", path: "/app/expenses", hint: "Expenses & travel" },
  { label: "Request leave", path: "/app/leave", hint: "Leave" },
  { label: "See benefits enrollment", path: "/app/leave", hint: "Leave · Benefits" },
  { label: "See my pay and W-4", path: "/app/payroll", hint: "Payroll" },
  { label: "Download a pay stub", path: "/app/payroll", hint: "Payroll" },
  { label: "Update my W-4", path: "/app/payroll?action=w4", hint: "Payroll" },
  { label: "Change my home address", path: "/app/profile", hint: "My profile" },
  { label: "See training due", path: "/app/profile", hint: "My profile" },
  { label: "Open a help desk ticket", path: "/app/helpdesk", hint: "Help desk" },
  { label: "Find my HR documents", path: "/app/documents", hint: "My documents" },
  { label: "View a project", path: "/app/projects", hint: "Projects" },
];

export function searchIntents(q: string, allowedPaths: Set<string>): IntentResult[] {
  const needle = q.trim().toLowerCase();
  if (!needle) return [];
  return INTENT_ACTIONS.filter(
    (a) =>
      allowedPaths.has(a.path.split("?")[0]) &&
      (a.label.toLowerCase().includes(needle) ||
        a.hint.toLowerCase().includes(needle) ||
        needle.split(/\s+/).every((w) => a.label.toLowerCase().includes(w) || a.hint.toLowerCase().includes(w))),
  ).slice(0, 8);
}

export function moduleById(id: string): ModuleDef | undefined {
  return MODULES.find((m) => m.id === id);
}
